import {motion} from "framer-motion";
import React from "react";

interface AnimatedTopBarProps {
    element: JSX.Element,
    disableAnimation?: boolean
}

export default function AnimatedTopBar({element, disableAnimation = false}: AnimatedTopBarProps) {
    return <motion.div
        initial={disableAnimation ? {opacity: 1, y: 0} : {opacity: 0, y: -20}}
        animate={{
            opacity: 1,
            y: 0
        }}
        exit={disableAnimation ? {opacity: 1, y: 0} : {opacity: 0, y: -20}}
        transition={disableAnimation ? {duration: 0} : {duration: 0.3}}
        className="py-2 px-3 text-center fw-bold"
        style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            zIndex: 1050,
            fontSize: "0.9rem",
            boxShadow: "0 2px 5px rgba(0,0,0,0.2)"
        }}
    >
        <motion.div
            style={{
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                zIndex: -1,
                backgroundColor: "#333333" // Dark grey background
            }}
        />
        <motion.span
            animate={disableAnimation ? 
                {color: "#f59e0c"} : 
                {color: ["#CC9900", "#FF6600", "#CC9900"]} // Dark yellow to orange and back
            }
            transition={disableAnimation ? 
                {duration: 0} : 
                {duration: 4, repeat: Infinity, ease: "easeInOut"}
            }
        >
            {element}
        </motion.span>
    </motion.div>
}